import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function MysticManorOpen() {
  const dateTexts = ['1896年', '1月', '1日'];
  const title = 'ヘンリー卿の博物館がオープンする';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/hkdl-att-mystic-manor-hero-00.jpg'
  const description = (
    <>
      {'世界中を旅して美術品などを収集していた'}
      <a href='/henry-mystic'>
        {'ヘンリーミスティック卿'}
      </a>
      {'が、コレクションを一般公開しようと考え、自身の邸宅を博物館としてオープンする。'}
    </>
  );
  const quoteDomain = 'hongkongdisneyland.com';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default MysticManorOpen;
